const scope = "lastBuySell";
export default scope;
